import { Chip } from '@lifebit-ai/lds'
import React from 'react'

import type {
  DiscoveryTableFilterWithConditions,
  TablesQuery
} from 'modules/cohort-browser/components/query/preview-query/types'
import { ColumnDataType } from 'modules/cohort-browser/enums'

import ChipContent from '../filters-view/ChipContent'
import { AdvancedQueryWrapper, FilterWrapper, FiltersViewWrapper, TableName } from './AdvancedQueryTablesView.styles'

interface AdvancedQueryTablesViewProps {
  query: TablesQuery
}

export const AdvancedQueryTablesView = ({ query }: AdvancedQueryTablesViewProps): JSX.Element => {
  const tables = query?.tables || []

  return (
    <AdvancedQueryWrapper>
      {tables.map((tableQuery, tableIndex) => (
        <React.Fragment key={tableQuery.schema + tableQuery.table}>
          <FilterWrapper>
            <TableName>{tableQuery.table}</TableName>

            <FiltersViewWrapper>
              {(tableQuery.filters as DiscoveryTableFilterWithConditions[]).map((filter, filterIndex) => {
                const columnType = (filter.column_type as ColumnDataType) || ColumnDataType.Text

                return (
                  <React.Fragment key={filter.column}>
                    <Chip bordered={false} withFixedWidth={false} content={ChipContent({ filter, columnType })} />
                    {filterIndex !== tableQuery.filters.length - 1 && (
                      <Chip withFixedWidth bordered={false} content={[{ type: 'operator', value: 'AND' }]} />
                    )}
                  </React.Fragment>
                )
              })}
            </FiltersViewWrapper>
          </FilterWrapper>
          {tableIndex !== query.tables.length - 1 && (
            <Chip bordered={false} withFixedWidth content={[{ type: 'operator', value: 'AND' }]} />
          )}
        </React.Fragment>
      ))}
    </AdvancedQueryWrapper>
  )
}
